import React from 'react';
import { Box, Divider, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ReviewReplyDisplay } from 'component/page/detail/Review/Review.selectors';
import { getTranslatedMonthYear } from 'core-framework/util/datetime/date';
import TextToggler from 'component/common/TextToggler/TextToggler';

interface OwnProps {
    reviewId: number;
    reviewReplies: ReviewReplyDisplay[];
}

type Props = OwnProps;

const REVIEW_REPLY_TEXT_LENGTH_LIMIT = 128;

const ReviewCardReplyDate: React.FC<{ replyDate: string; reviewId: number; replyId: number; replyAuthorType: string }> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    if (!props.replyDate || !props.replyAuthorType) {
        return null;
    }

    const reviewReplyDateDisplay = getTranslatedMonthYear(cms, props.replyDate);
    const reviewReplyDateComponent = (
        <Typography variant="caption-default" key={`${props.reviewId}-reply-${props.replyId}`}>
            {reviewReplyDateDisplay}
        </Typography>
    );
    const reviewReplyDate = StringFormatter.formatToJsx(cms[272060], props.replyAuthorType, reviewReplyDateComponent);
    return (
        <Typography variant="caption-default-strong" textColor="base.subtle">
            {reviewReplyDate}
        </Typography>
    );
};

ReviewCardReplyDate.displayName = 'ReviewCardReplyDate';

const ReviewCardReply: React.FC<Props> = (props) => {
    if (!props.reviewReplies || props.reviewReplies.length === 0 || !props.reviewReplies[0]) {
        return null;
    }

    const reviewReply = props.reviewReplies[0];

    return (
        <Box mt="16" display="flex">
            <Box display="inline-block">
                <Divider ms="16" direction="vertical" color="base.default" />
            </Box>
            <Box ms="12" display="inline-block">
                <Typography variant="body-s">
                    <TextToggler text={reviewReply.replyText} threshold={REVIEW_REPLY_TEXT_LENGTH_LIMIT} defaultExpanded={false} />
                </Typography>
                <ReviewCardReplyDate replyDate={reviewReply.replyDate} reviewId={props.reviewId} replyId={reviewReply.replyId} replyAuthorType={reviewReply.replyAuthorType} />
            </Box>
        </Box>
    );
};

ReviewCardReply.displayName = 'ReviewCardReply';
export default ReviewCardReply;
